import Prism from 'prismjs';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-kotlin';
import 'prismjs/components/prism-swift';
import {copyToClipboard} from '../helpers/StringHelper';

export class CodeSamplesComponent {
  container = document.querySelector('.code-samples-shortcode-wrapper');

  copyTooltipTimeout = null;

  constructor() {
    if (!this.container) {
      return;
    }

    this.addEventListeners();

    this.initialize();
  }

  addEventListeners() {
    const languages = this.container.getElementsByClassName('js-code-language');
    if (languages.length) {
      Array.from(languages).forEach((language) => {
        language.addEventListener('click', (e) => this.languageClickHandler(e));
      });
    }

    const copyButton = this.container.querySelector('.js-copy');
    if (copyButton) {
      copyButton.addEventListener('click', (e) => this.copyButtonClickHandler(e));
    }
  }

  initialize() {
    this.highlightCode('javascript', 'javascript');
    this.highlightCode('html', 'html');
    this.highlightCode('java', 'java');
    this.highlightCode('kotlin', 'kotlin');
    this.highlightCode('swift', 'swift');
  }

  languageClickHandler(e) {
    const target = e.target;

    if (target.classList.contains('active')) {
      return;
    }

    const index = [...target.parentNode.children].indexOf(target);

    const activeLanguage = this.container.querySelector('.js-code-language.active');
    if (activeLanguage) {
      activeLanguage.classList.remove('active');
      target.classList.add('active');
    }

    const panes = this.container.querySelectorAll('.code-samples-list__item');
    if (panes.hasOwnProperty(index)) {
      const activePane = this.container.querySelector('.code-samples-list__item.active');
      if (activePane) {
        activePane.classList.remove('active');
      }

      panes[index].classList.add('active');
    }
  }

  highlightCode(name, language) {
    const code = this.container.querySelector(`pre.${name} code`);
    if (code) {
      const html = Prism.highlight(code.textContent, Prism.languages[language], language);
      code.innerHTML = '';
      code.insertAdjacentHTML('afterbegin', html);
    }
  }

  copyButtonClickHandler(e) {
    const activePane = this.container.querySelector('.code-samples-list__item.active');
    if (activePane) {
      copyToClipboard(activePane.innerText);
      this.showCopyToolTip();
    }
  }

  showCopyToolTip() {
    const tooltip = this.container.querySelector('.tooltip_copied');
    if (tooltip) {
      clearTimeout(this.copyTooltipTimeout);

      tooltip.classList.add('active');

      this.copyTooltipTimeout = setTimeout(() => {
        tooltip.classList.remove('active');
      }, 1000);
    }
  }
}